import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  availability: {
    id: 'manage-services.components.availability-details.availability',
    defaultMessage: 'Availability',
  },
  repeatsOn: {
    id: 'manage-services.components.availability-details.repeats-on',
    defaultMessage: 'Repeats on',
  },
  timeRange: {
    id: 'manage-services.components.availability-details.time-range',
    defaultMessage: '{startTime, date, time} - {endTime, date, time}',
  },
  availableSingleDayExceptions: {
    id: 'manage-services.components.availability-details.available-single-day-exceptions',
    defaultMessage: 'Single day exceptions - Available',
  },
  unavailableSingleDayExceptions: {
    id: 'manage-services.components.availability-details.unavailable-single-day-exceptions',
    defaultMessage: 'Single day exceptions - Unavailable',
  },
});
